import { Link, useLocation } from 'react-router-dom';
import { BarChart3, Gauge, Settings } from 'lucide-react';

import { AppContent } from '@/components/layout/AppLayout';
import { cn } from '@/lib/utils';

const navItems = [
	{ path: '/input', label: '入力', icon: Gauge },
	{ path: '/analytics', label: '分析', icon: BarChart3 },
];

export const TaxiNav = () => {
	const location = useLocation();
	const isSettings = location.pathname === '/settings';

	return (
		<nav className="sticky top-0 z-10 border-b bg-white">
			<AppContent className="py-2">
				<div className="flex items-center gap-2">
					<div className="grid flex-1 grid-cols-2 gap-2">
						{navItems.map((item) => {
							const isActive =
								location.pathname === item.path ||
								(item.path === '/input' && location.pathname === '/');
							const Icon = item.icon;
							return (
								<Link
									key={item.path}
									to={item.path}
									className={cn(
										'rounded-md border px-3 py-2 text-center text-sm font-medium flex items-center justify-center gap-1.5',
										isActive
											? 'bg-primary text-primary-foreground border-primary'
											: 'bg-white hover:bg-slate-50',
									)}
								>
									<Icon className="h-4 w-4" />
									{item.label}
								</Link>
							);
						})}
					</div>
					<Link
						to="/settings"
						className={cn(
							'rounded-md border px-3 py-2 text-sm font-medium flex items-center gap-1.5',
							isSettings
								? 'bg-primary text-primary-foreground border-primary'
								: 'bg-white hover:bg-slate-50',
						)}
					>
						<Settings className="h-4 w-4" />
						設定
					</Link>
				</div>
			</AppContent>
		</nav>
	);
};
